import {
  TerminLegalneDefinicieUpdate,
  TerminLegalneDefinicieUpdateApi,
} from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import Definicia from '../../model/Definicia';

const client = new TerminLegalneDefinicieUpdateApi(apiConfiguration(tezauryPrefixPath));

function map(legalneDefinicieUpdate: Array<Definicia>): TerminLegalneDefinicieUpdate {
  return {
    legalnaDefiniciaList: legalneDefinicieUpdate.map(definicia => ({
      uuid: definicia.uuid,
      definicia: definicia.definicia,
      popisLegislativnehoZdroja: definicia.popisLegislativnehoZdroja,
      zdroj: definicia.zdroj,
    })),
  };
}

// eslint-disable-next-line import/prefer-default-export
export const updateLegalneDefinicie = async (
  terminUuid: Uuid,
  legalneDefinicieUpdate: Array<Definicia>,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { data, status } = await client.updateTerminLegalneDefinicie(
    terminUuid,
    map(legalneDefinicieUpdate),
    options,
  );
  return { data, responseCode: status };
};
